import React, { useRef, useState, useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Button } from "antd-mobile-v5";
import "./scaleIframe.scss";
import { eproScaleUrl } from '../../config/config'

type ScaleIframeType = "pgwj" | "pgjg";

const ScaleIframe = (
  props: RouteComponentProps<{ scaleCode: string; type: ScaleIframeType; recordId: string }>
) => {
  const { scaleCode, type, recordId } = props.match.params;
  const [iframeUrl, setIframeUrl] = useState("");
  const [iframeTitle, setIframeTitle] = useState<ScaleIframeType | null>(null);

  useEffect(() => {
    if (type === "pgwj") {
      setIframeUrl(`${eproScaleUrl}epro/evaluation/${scaleCode}?disabled=true&recordId=${recordId}`);
      setIframeTitle("pgwj");
    } else {
      setIframeUrl(`${eproScaleUrl}scale/report/${recordId}/${scaleCode}`);
      setIframeTitle("pgjg");
    }
  }, []);

  const goBack = () => {
    props.history.go(-1)
  }

  return (
    <div className="scale-iframe">
      {iframeUrl && (
        <iframe
          src={iframeUrl}
          id={type}
          title={iframeTitle!}
          className="scale-iframe--container"
        ></iframe>
      )}
      <div className="scale-iframe--btn">
        <Button shape="rounded" color="default" className="iframe-btn--back" onClick={goBack} >
          返回
        </Button>
      </div>
    </div>
  );
};

export default withRouter(ScaleIframe);
